import { useAuthorization } from "@sttedra_ui/framework";

import WorkspacesView from "../workspaces/WorkspacesView.vue";

export default [
  {
    path: "/admin/Workspaces",
    name: "Workspaces",
    component: WorkspacesView,
    meta: { title: "Workspaces", requiresAuthentication: false },
    beforeEnter: async (to, from, next) => {
      localStorage.setItem("layout", "admin");

      const { modelRef: authorizationModelRef } = useAuthorization();

      const userRol = authorizationModelRef.value.roles[0];

      if (userRol != "Admin") {
        next({ name: "Login" });
      }

      next();
    },
  },
];
